import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import clsx from 'clsx';

interface CardSectionProps {
	children: React.ReactNode;
	className?: string;
	icon: IconDefinition;
	title: string;
}

const CardSection: React.FC<CardSectionProps> = ({
	children,
	className,
	icon,
	title,
}) => (
	<div
		className={clsx('space-y-6 bg-gray-50 rounded-lg p-6 shadow-md', className)}
		style={{
			boxShadow:
				'0 -2px 6px -2px rgba(0,0,0,0.10), 0 4px 6px -1px rgba(0,0,0,0.1)',
		}}
	>
		<h2
			className={`
				flex items-center gap-2 text-lg font-bold text-gray-800
				${className}
				`}
		>
			<FontAwesomeIcon icon={icon} />
			{title}
		</h2>
		{children}
	</div>
);

export default CardSection;
